import SignItDefault from 'components/forms/sections/SignIt';
import {SiteUrls} from 'constants.js';

const SignIt = ({formID, imageUrl, ...props}) => {
    return (
        <SignItDefault
            imageUrl={imageUrl}
            redirectOnSuccess
            endpoint={`cg719s/${formID}/sign`}
            buttonText='Submit Signed CG719S'
            redirectUrl={SiteUrls.SEA_SERVICE_DOCS}
        />
    );
};

export default SignIt;
